import React from 'react';
import './Hygiene.css';
import maid from '../assets/img/maid.svg';
import tissues from '../assets/img/tissues.svg';
import value from '../assets/img/value.svg';

class Hygiene extends React.Component {
  constructor() {
    super();

    this.headers = [
      {
        code: "PL",
        text1: "W trosce o Twoje zdrowie",
        text2: "Najwyższa higiena oraz jakość zabiegów podologicznych"
      }
    ]
  }

  render() {
    return (
      <section className="hygiene">
        <div className="container">
          <h2>{this.headers[0].text1}</h2>
          <h3>{this.headers[0].text2}</h3>

          <div className="hygiene-boxes">
            <div>
              <img src={maid} alt="Wykształceni podolodzy"></img>
              <h4>Wykształcony zespół</h4>
              <p>
                Zarówno ja, jak i osoby ze mną współpracujące to fachowcy z odpowiednim
                wykształceniem oraz przeszkoleniem.
              </p>
            </div>

            <div>
              <img src={tissues} alt="Dbanie o higienę"></img>
              <h4>Dezynfekcja oraz sterylizacja</h4>
              <p>
                Korzystamy zarówno z przyborów narzędzi jednorazowego jak 
                i wielokrotnego użytku. Procesy utylizacji narzędzi jednorazowych 
                oraz sterylizacja narzędzi wielokrotnego użytku podlegają 
                najwyższym standardom związanym z bezpieczeństwem i  
                higieną. W kwestii jakości, nie ma kompromisów.
              </p>
            </div>

            <div>
              <img src={value} alt="Wykształceni podolodzy"></img>
              <h4>Wysokiej jakości efekt końcowy</h4>
              <p>
                Wierzymy, że zabiegi podologiczne wymagają ogromnej staranności,
                indywidualnego podejścia i nadążania za rosnącymi standardami. Chcemy 
                dawać to, co w naszym zawodzie najlepsze.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Hygiene;
